import * as types from '../Actions/types';

const INIT_STATE = {
    pageLoading: false
};

const Common = (state = INIT_STATE, action) => {
    switch(action.type) {
        case types.PAGE_LOADING: 
            return {
                ...state,
                pageLoading: action.loading
            }

        default:
            return state;
    }
};

export default Common;